module.exports = __webpack_public_path__ + "static/media/logo-acordo-seguro-cadeado.b2c5a5cb.png";